import { API } from '../Api';

export interface ClanPostStats {
  totalPosts: number;
  totalLikes: number;
  totalComments: number;
  totalViews: number;
}

export interface ClanPostItem {
  id: string;
  shortId?: string;
  title?: string;
  content?: string;
  createdAt: string;
  userId: string;
  userFullName?: string;
  username?: string;
  userAvatar?: string;
  likesCount: number;
  commentsCount: number;
  viewCount: number;
}

export interface ClanPostsResponse {
  stats: ClanPostStats;
  posts: ClanPostItem[];
  hasMore: boolean;
  pageNumber: number;
  pageSize: number;
  total: number;
}

// Bài viết của các thành viên trong bang + thống kê tương tác tổng.
export const getClanPosts = (
  userIds: string[],
  pageNumber = 1,
  pageSize = 10
) => {
  return API.post<ClanPostsResponse>('/v1/post-service/posts/clan-feed', {
    userIds,
    pageNumber,
    pageSize,
  }).then((res) => res.data);
};
